import Typography from '@mui/material/Typography';
import React from 'react';
import Link from '@mui/material/Link';

const ProfileName = props => {
  const { username, displayName, roles } = props.author;

  const isTeamBadge = roles && roles.indexOf('team') !== -1;

  if (props.authorNotClickable)
    return (
      <span className="textPrimary">
        <strong>{displayName}</strong>
      </span>
    );
  return (
    <>
      <Link color="textPrimary" href={`/@${username}`} legacyBehavior>
        <a className="hoverline">
          <div className={props.noInline ? undefined : 'd-inline'}>
            <strong>
              {username === displayName ? `@${username}` : displayName}
            </strong>
          </div>
          {username !== displayName && (
            <Typography
              color="textSecondary"
              variant="subtitle2"
              display="inline"
            >
              {' '}
              @{username}
            </Typography>
          )}
        </a>
      </Link>
      {isTeamBadge && (
        <span className="ml-1 pt-1 badge badge-success">Team</span>
      )}
    </>
  );
};

export default ProfileName;
